import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    // The instance-level default Content-Type: application/json would
    // otherwise override the multipart boundary the browser needs to set
    // itself for a FormData body, so the server never sees any fields at
    // all (a 422 "file: Field required" with no multipart data received).
    delete config.headers['Content-Type'];
  }
  return config;
});

export default apiClient;
